import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { fetchDRCList_action, delateDRC_action } from "../../../actions/admin_module_action/daily_routine_checklist_action/daily_routine_checklist_action";
import { exhibitionId, serviceTypeId, toastError, contractorListActionId, toastSuccess, responsiblePersonListctionId, hallActionId, HallZoneActionId, HallZoneListActionId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import DatePicker from "react-datepicker";
import moment from 'moment';
import zIndex from "@mui/material/styles/zIndex";


class DailyRoutineChecklistList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            title: '',
            fromDate: '',
            toDate: '',
            Area: '',
            Rperson: '',
            AreaList: [],
            RpList: [],
            DRCList: [],
            DailyRoutineChecklistHdrID: '',
        }
        this.updateItem = this.updateItem.bind(this)
        this.renderList = this.renderList.bind(this)
        this.clearValue = this.clearValue.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getDRCList = this.getDRCList.bind(this)
        this.deleteDRC = this.deleteDRC.bind(this)
    }
    componentDidMount() {
        this.getFillList(hallActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getFillList(responsiblePersonListctionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '');
        this.getDRCList()


    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === hallActionId) {
                            this.setState({ AreaList: data.data })
                            resolve()

                        }
                        if (actionID === responsiblePersonListctionId) {
                            this.setState({ RpList: data.data })
                            resolve()

                        }
                    }
                })
        })
    }

    deleteDRC() {
        const { isLoading, title, DRCList, fromDate, DailyRoutineChecklistHdrID, toDate, Area, Rperson, AreaList, RpList } = this.state
        this.setState({ isLoading: true })
        this.props.delateDRC_action(DailyRoutineChecklistHdrID)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data.length > 0) {
                    // if (data.data[0].length > 0) {
                    // this.setState({ DRCList: data.data, })
                    // }
                    toastSuccess("Record deleted successfully")
                    this.getDRCList()
                    // }
                    this.setState({ isLoading: false, isOpen: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getDRCList() {
        const { isLoading, title, DRCList, fromDate, toDate, Area, Rperson, AreaList, RpList } = this.state
        // console.log(moment(fromDate).format("YYYY-MM-DD"))
        this.setState({ isLoading: true })
        this.props.fetchDRCList_action(title, fromDate != '' && fromDate != null ? moment(fromDate).format("YYYY-MM-DD") : '', toDate != '' && toDate != null ? moment(toDate).format("YYYY-MM-DD") : '', Area, Rperson)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data.length > 0) {
                    // if (data.data[0].length > 0) {
                    this.setState({ DRCList: data.data, })
                    // }
                    // }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    renderList(currentRecords) {
        const { isLoading, title, DRCList, fromDate, toDate, Area, Rperson, AreaList, RpList } = this.state
        return (
            <>
                <table class="table table-hover table-striped border">
                    <thead class="table-light" style={{ position: 'sticky', top: '0', zIndex: '0' }}>
                        <tr>
                            {/* <th class="text-center">Sr No.</th> */}
                            <th>Activity</th>
                            <th>From - To Date</th>
                            <th>Schedule Time</th>
                            <th>Area</th>
                            <th>Responsible Person</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentRecords.length > 0 ? currentRecords.map((item, i) => (
                            <tr>
                                {/* <td class="text-center">{i + 1}</td> */}
                                <td>{item.ProgramTitle}</td>
                                <td>{moment(item.FromDate).format("DD/MM/YYYY")}-{moment(item.ToDate).format("DD/MM/YYYY")}</td>
                                <td>{item.ScheduleTimes}</td>
                                <td>{item.HallName}</td>
                                <td>{item.ResponsiblePerson}</td>
                                <td class="text-center act-col" >
                                    {/* <a href="daily-routine-checklist-add.html"> */}
                                    {/* <i class="bi bi-pencil text-success" title="Update checklist" onClick={() => this.handleUpdate(item.DailyRoutineChecklistHdrID)}></i>
                                    <span style={{ color: '#ccc' }}> | </span> */}
                                    <i class="bi bi-trash text-danger" title="delete checklist" onClick={() => this.setState({ isOpen: true, DailyRoutineChecklistHdrID: item.DailyRoutineChecklistHdrID })} ></i>
                                </td>
                            </tr>)) : <tr>
                            <td colSpan={12} className="text-center">Record not found</td>
                        </tr>}
                    </tbody>
                </table>
            </>
        )
    }

    // Update Current Page
    updateItem(item) {
        const { accountEntryPassList } = this.state
        this.setState({ currentPage: item });
    }
    clearValue() {
        this.setState({
            title: '',
            // DRCList:''
            fromDate: '',
            toDate: '',
            Area: '',
            Rperson: '',
            // AreaList
            // RpList
        })
        setTimeout(() => {
            this.getDRCList()
        }, 100);
    }

    handleUpdate(id) {
        if (id != null) {
            this.props.navigate('/dailyRoutineChecklistSetup', { state: { DailyRoutineChecklistHdrID: id } })
        } else {
            this.props.navigate('/dailyRoutineChecklistSetup')
        }
    }

    render() {
        const { isLoading, isOpen, title, currentPage, DRCList, fromDate, toDate, Area, Rperson, AreaList, RpList } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = DRCList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(DRCList.length / recordsPerPage)
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                {/* <HeaderWithLogo /> */}
                <>
                    <AdminDrawer />
                    {/* <div className="app-content with-dr-container com-height"> */}
                    <div className="main-content app-content mt-0">
                        <div className="app-content with-dr-container com-height">
                            <div className="main-container">
                                <div className="row m-0">
                                    <div className="breadcrumb-scroll-fixed">
                                        <div className="position-relative">
                                            <h6 className="mb-0 p-2 text-white">Daily Routine Checklist Setup</h6>
                                            <button class="btn btn-aqua p-1 px-2 add-checklist-btn" onClick={() => this.handleUpdate(null)}>
                                                Add Daily Routine Checklist
                                            </button>
                                        </div>
                                    </div>

                                </div>
                                <main id="main" class="py-2 px-2 admin-top-space-add-routine">
                                        <div class="row m-0">
                                                            <div className="d-flex flex-column flex-md-row align-items-md-end gap-2 w-100 mb-2 p-0">

                                                                {/* Activity */}
                                                                <div className="col-12 col-md-2">
                                                                    <label>Activity</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={title}
                                                                        onChange={(e) => this.setState({ title: e.target.value })}
                                                                    />
                                                                </div>

                                                                {/* From Date */}
                                                                <div className="col-12 col-md-2">
                                                                    <label>From Date</label>
                                                                    <DatePicker
                                                                        className="form-control w-100"
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={fromDate ? new Date(fromDate) : null}
                                                                        onChange={(e) => this.setState({ fromDate: e })}
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        placeholderText="dd-mm-yyyy"
                                                                    />
                                                                </div>

                                                                {/* To Date */}
                                                                <div className="col-12 col-md-2">
                                                                    <label>To Date</label>
                                                                    <DatePicker
                                                                        className="form-control w-100"
                                                                        dateFormat="dd-MM-yyyy"
                                                                        selected={toDate ? new Date(toDate) : null}
                                                                        onChange={(e) => this.setState({ toDate: e })}
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        placeholderText="dd-mm-yyyy"
                                                                    />
                                                                </div>

                                                                {/* Area */}
                                                                <div className="col-12 col-md-2">
                                                                    <label>Area</label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={Area}
                                                                        onChange={(e) => this.setState({ Area: e.target.value })}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {AreaList.length > 0 &&
                                                                            AreaList.map((data) => (
                                                                                <option key={data.HallId} value={data.HallId}>
                                                                                    {data.HallName}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>

                                                                {/* Responsible Person */}
                                                                <div className="col-12 col-md-2">
                                                                    <label>Responsible Person</label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={Rperson}
                                                                        onChange={(e) => this.setState({ Rperson: e.target.value })}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {RpList.length > 0 &&
                                                                            RpList.map((data) => (
                                                                                <option key={data.AccountID} value={data.AccountID}>
                                                                                    {data.Name}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>

                                                                {/* Buttons */}
                                                                <div className="d-flex gap-2 col-12 col-md-auto mt-2 mt-md-0">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-aqua"
                                                                        onClick={() => this.getDRCList()}
                                                                    >
                                                                        Search
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-gray"
                                                                        onClick={() => this.clearValue()}
                                                                    >
                                                                        Clear
                                                                    </button>
                                                                </div>

                                                            </div>

                                                            <div class="row m-0">

                                                                <div class="table-responsive p-0">
                                                                    {this.renderList(currentRecords)}
                                                                </div>
                                                            </div>
                                                            <div class="d-flex justify-content-between align-items-center mt-3">
                                                                <div class="text-muted page-count">
                                                                    Page <strong>{currentPage}</strong> of <strong>{nPages}</strong>
                                                                </div>
                                                                {
                                                                    DRCList.length > 0 ?
                                                                        <Pagination
                                                                            nPages={nPages}
                                                                            currentPage={currentPage}
                                                                            setCurrentPage={this.updateItem}
                                                                        /> : <></>
                                                                }
                                                            </div>
                                        </div>
                                </main>
                            </div>
                        </div>
                    </div>

                    <Modal isOpen={this.state.isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                        <div className="modal-dialog">
                            <div className="modal-content confirm-logout">
                                <div class="modal-header bg-danger text-white py-2">
                                    <p class="modal-title" style={{ fontSize: "16px" }}>     Confirm Delete</p>
                                    <button type="button" class="btn-close btn-close-white text-white" onClick={() => this.setState({ isOpen: false, })} ></button>
                                </div>
                                <div class="modal-body">
                                    {/* <div class="mb-0">
                                                                    <label class="col-form-label">Reason</label>
                                                                    <textarea id="refuseReason" class="form-control" rows="4" placeholder="Enter reason here..." onChange={(e) => this.setState({ refuseReason: e.target.value })} value={this.state.refuseReason}></textarea>
                                                                </div> */}
                                    <p class="pop_label">Do you really want to delete this Record?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-gray bg-secondary" onClick={(e) => this.deleteDRC(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray bg-secondary" onClick={() => this.setState({ isOpen: false, })}>No</button>

                                    {/* <button type="button" class="btn btn-danger" onClick={() => this.onGenerateExitPass(0)}>Refuse</button> */}
                                </div>
                            </div>
                        </div>
                    </Modal>
                </>
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action,
    fetchDRCList_action, delateDRC_action
})(DailyRoutineChecklistList));